import React, {Suspense, useMemo, useRef, lazy} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import {connect} from 'react-redux';
import {filters} from '../../drupalSettings';
import filterChange from '../../actions/filterChange';
import {MODULE_SPECIAL_RATES} from '../../constants';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';
import ModulePreview from '../../components/ModulePreview';
import Button from 'js/components/shared/Button';

import styles from './SearchModuleSpecialRates.module.scss';

const cx = classnames.bind(styles);

const ModuleSpecialRatesForm = lazy(() => import('./components/ModuleSpecialRatesForm'));

const SearchModuleSpecialRates = function ({
   data = {},
   className = null,
   activeFilter = null,
   filterChangeAction,
   preview = 'button',
}) {
  const toglerRef = useRef(null);
  const isActive = useMemo(() => activeFilter === MODULE_SPECIAL_RATES, [activeFilter]);
  const previewValues = useMemo(function () {
    return [{
      label: filters.code.label,
      value: '',
      readOnly: true,
    }];
  }, [filters]);
  const onPreviewClick = function (e) {
    if (!isActive) {
      e?.preventDefault();
      filterChangeAction('activeFilter', MODULE_SPECIAL_RATES);
    } else {
      onFormClose();
    }
  };

  const onFormClose = function () {
    filterChangeAction('activeFilter', null);
    pushFiltersClose('code');
  };

  const onCodeFormSubmit = function () {
    pushFiltersApply('code');
  };

  return (
    <div className={cx('root', className)}>
      {preview === 'link' && (<Button
        theme="link"
        onClick={onPreviewClick}
        className={cx('link')}
      >{filters.code.label}</Button>)}
      {preview === 'button' && (<ModulePreview
        icon="POURCENTAGE"
        type={preview}
        ref={toglerRef}
        values={previewValues}
        onClick={onPreviewClick}
      />)}
      {isActive && (
        <Suspense>
          <ModuleSpecialRatesForm
            data={data}
            togler={toglerRef.current}
            onSubmit={onCodeFormSubmit}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleSpecialRates.propTypes = {
  data: PropTypes.any,
  className: PropTypes.string,
  activeFilter: PropTypes.string,
  filterChangeAction: PropTypes.func.isRequired,
  preview: PropTypes.oneOf(['link', 'button']),
}

export default connect(({searchBox, main}) => ({
  data: main?.setting?.businessCodeFilter,
  activeFilter: searchBox?.activeFilter,
}), {
  filterChangeAction: filterChange,
})(SearchModuleSpecialRates);
